import { createSelector, MemoizedSelector } from '@ngrx/store';
import { StateUtils } from '@spartacus/core';
import { MyAccountState, StateWithMyAccount } from '../my-account-state';
import { getMyAccountState } from './state.selectors';

export const deleteManager: MemoizedSelector<StateWithMyAccount, StateUtils.EntityLoaderState<string>> = createSelector(
  getMyAccountState,
  (state: MyAccountState) => state.deleteManager,
);

export const deleteManagerLoading = (personalManagerId: string): MemoizedSelector<StateWithMyAccount, boolean> =>
  createSelector(deleteManager, (state: StateUtils.EntityLoaderState<string>) =>
    StateUtils.entityLoadingSelector(state, personalManagerId),
  );

export const deleteManagerError = (personalManagerId: string): MemoizedSelector<StateWithMyAccount, boolean> =>
  createSelector(deleteManager, (state: StateUtils.EntityLoaderState<string>) =>
    StateUtils.entityErrorSelector(state, personalManagerId),
  );

export const deleteManagerSuccess = (personalManagerId: string): MemoizedSelector<StateWithMyAccount, boolean> =>
  createSelector(deleteManager, (state: StateUtils.EntityLoaderState<string>) =>
    StateUtils.entitySuccessSelector(state, personalManagerId),
  );
